/* Http Client */
import request from '@/utils/http/request'


export const STATUS = {
    1: "啟用",
    0: "停用",
}
//List
export async function fetchAll({ mchName, state, pageSize, pageNumber }) {
    return await request.get('/mchInfo', {
        params: {
            mchName, state, pageSize, pageNumber
        }

    });
}

//運動類型詳情
export async function fetch(id) {
    return await request.get(`/mchInfo/${id}`);
}

//運動類型添加
export async function store({ id, mchName, mchShortName, loginUserName, contactName, contactTel, contactEmail, remark, state }) {
    return await request.post('/mchInfo', {
        id, mchName, mchShortName, loginUserName, contactName, contactTel, contactEmail, remark, state
    });
}


export async function update({ id, mchName, mchShortName, loginUserName, contactName, contactTel, contactEmail, remark, state }) {
    return await request.put(`/mchInfo/${id}`, {
        id, mchName, mchShortName, loginUserName, contactName, contactTel, contactEmail, remark, state
    });
}
//運動類型刪除
export async function destroy(id) {
    return await request.delete(`/mchInfo/${id}`);
}


